import { Image, makeStyles } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    logo: {
        display: "flex",
        margin: '0 auto', // Center logo for mobile view
        
        '@media (min-width: 600px)': { // Remove margin for larger screens
            margin: '0',
        },
    }
});

const Logo = () => {
    const { t } = useTranslation("general");
    const styles = useStyles();
    
    return (
        <Image
            loading="lazy"
            fetchPriority="low"
            src="/img/logos/dolphin-solutions_logo_blue-white.png"
            alt={t("companyName")}
            className={styles.logo}
            width={185}
            height={60}
            />
    );
}

export default Logo;